module.exports = __webpack_public_path__ + "static/media/twitter-d.12f5296d.svg";